<template>
    <span>
    <el-form label-position="top">
        <el-form-item label="Remove lines containing the following phrases">
            <el-input
                    type="textarea"
                    :rows="3"
                    placeholder="Enter phrases to remove, one per line."
                    v-model="overrides">
            </el-input>
        </el-form-item>
    </el-form>
    </span>
</template>

<script>
    export default {
        props: [
        ],
        data() {
            return {
                'overrides': ''
            }
        }
    }
</script>
